export default __webpack_public_path__ + "static/media/main-bar-group@2x.e01e7801.png";